import { render } from "./EditPeriodPage.vue?vue&type=template&id=dab13e38"
import script from "./EditPeriodPage.vue?vue&type=script&lang=js"
export * from "./EditPeriodPage.vue?vue&type=script&lang=js"

import "./EditPeriodPage.vue?vue&type=style&index=0&id=dab13e38&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__